import { Cell as ExcelCell } from 'exceljs';
import { Column, Row } from '@devexpress/dx-react-grid';
import { customizeDateColumns } from '../helpers';
import { formatDateTime } from 'utils/helpers';
import { dateColumnsName } from './constants';

export const customizeCell = (cell: ExcelCell, row: Row, column: Column) => {
  customizeDateColumns(cell, row, column, ['messageDate'])
};

export const valuesConverter = (data: Row[]) => {
  return data.map((row) => {
    const formattedRow = { ...row };
    dateColumnsName.forEach((columnName) => {
      if (row[columnName]) {
        formattedRow[columnName] = formatDateTime(row[columnName]);
      }
    });
    return formattedRow;
  });
};

